import { render } from "./received.vue?vue&type=template&id=32aa86bd&scoped=true"
import script from "./received.vue?vue&type=script&lang=js"
export * from "./received.vue?vue&type=script&lang=js"

import "./received.vue?vue&type=style&index=0&id=32aa86bd&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aa86bd"]])

export default __exports__